/**
 * parser.js
 * Description: accepts an array of token objects and checks if the the syntax of every line is correct
 *              returns a parse tere
 */

/* eslint-disable react-hooks/rules-of-hooks */

import { checkNextToken } from "./helpers";
import { parseStatement } from "./grammars";

// ----------------------------------------
// From the list of tokens, analyze if tama yung type nung kasunod
// Analyzes if list of tokens follows LOLCode Grammar
// Throws error if any problems are found (outputError(message, token))

export const parser = (tokens) => {
  if (!tokens) return;

  let syntaxTree = [];

  // [START] Check if first statement is HAI
  let HAI_token = checkNextToken(-1, tokens, "CODE_START");
  syntaxTree.push(HAI_token);

  // Analyze each token between HAI and KTHXBYE
  for (let i = 1; i < tokens.length - 1; i++) {
    i = parseStatement(i, tokens, syntaxTree);
  }

  // [END] Checks if last token is KTHXBYE
  let KTHXBYE_token = checkNextToken(tokens.length - 2, tokens, "CODE_END");
  syntaxTree.push(KTHXBYE_token);

  return syntaxTree;
};
